import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface TranslatorProps {
  path: string;
}

const Translator = ({ path }: TranslatorProps): ReactElement => {
  const { t } = useTranslation();
  return <>{t(path)}</>;
};

export default Translator;
